import { Outlet } from 'react-router-dom';
import { Col, Row } from 'antd';
import Globe3D from '../molecules/globe-3d.component';
const AuthLayout = () => {

const hostname = window.location.hostname;
const logoScr = '/LOGOBLANCO.png';

const smallLogoScr = '/LOGOBLANCO.png';
  return (
    <div className="auth-page-wrapper">
      <Row className="auth-main-row" align="stretch" style={{ position: 'relative' }}>
        {/* Identity Section - Original Balanced Split */}
        <Col xs={0} sm={0} md={12} lg={12} className="auth-left-identity">
          <div className="liquid-bg-container">
            <div className="liquid-bg">
              <div className="wave wave-1" />
              <div className="wave wave-2" />
              <div className="wave wave-3" />
            </div>
            <div className="auth-identity-content">
               <div className="globe-branding-wrapper" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  {/* The Globe */}
                  <div style={{ pointerEvents: 'auto' }}>
                     <Globe3D />
                  </div>
                  
                  {/* The Centered Logo */}
                  <div style={{ 
                    position: 'absolute', 
                    top: '50%', 
                    left: '50%', 
                    transform: 'translate(-50%, -50%)',
                    zIndex: 100,
                    pointerEvents: 'none'
                  }}>
                    <img 
                      className="auth-logo-brand brand-tecnocom" 
                      src="/LOGOBLANCO.png" 
                      alt="Tecnocom Logo" 
                      style={{ 
                        width: '280px',
                        maxWidth: '80vw',
                        filter: "brightness(0) invert(1) drop-shadow(0 0 20px rgba(255,255,255,0.4))",
                        animation: "float 6s infinite ease-in-out"
                      }} 
                    />
                  </div>
               </div>
            </div>
          </div>
        </Col>

        {/* Form Section - Original Balanced Split */}
        <Col xs={24} sm={24} md={12} lg={12} className="auth-right-workspace">
          <div className="pattern-overlay" />
          <div className="auth-card-container">
             <div className="login-floating-card">
                <div className="mobile-logo-container">
                   <img src={smallLogoScr} alt="Mobile Logo" className="mobile-logo" />
                </div>
                <Outlet />
             </div>
          </div>
        </Col>
      </Row>

      <style>{`
        .auth-page-wrapper {
          width: 100%;
          min-height: 100vh;
          background: #f8fafc;
          overflow: hidden;
        }

        .auth-main-row {
          min-height: 100vh;
        }

        /* LEFT SIDE: Identity & Liquid */
        .auth-left-identity {
          position: relative;
          background: #1e3a8a;
          z-index: 20;
          overflow: hidden;
        }

        .liquid-bg-container {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .auth-identity-content {
          position: relative;
          z-index: 10;
          text-align: center;
          padding: 60px;
        }

        .auth-logo-brand.brand-tecnocom {
          max-width: 320px;
          height: auto;
          filter: drop-shadow(0 20px 40px rgba(0,0,0,0.4));
        }

        .auth-logo-brand.brand-tecimac {
          max-width: 210px;
          height: auto;
          filter: drop-shadow(0 12px 25px rgba(0,0,0,0.25));
        }

        .co-branding-container {
           display: flex;
           align-items: center;
           justify-content: center;
           gap: 50px; /* Increased gap for larger logos */
           margin-bottom: 35px;
        }

        .brand-divider-plus {
           color: rgba(255, 255, 255, 0.4);
           font-size: 24px;
           font-weight: 300;
        }

        .corporate-group-tag {
           color: rgba(255, 255, 255, 0.7);
           font-size: 14px;
           font-weight: 700;
           letter-spacing: 3px;
           text-transform: uppercase;
        }

        .diagonal-border {
          position: absolute;
          top: 0; right: 0; bottom: 0;
          width: 15px;
          background: #3b82f6;
          z-index: 5;
          opacity: 0.8;
        }

        /* RIGHT SIDE: Workspace & Pattern */
        .auth-right-workspace {
          background: #ffffff;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px;
          z-index: 10;
        }

        .pattern-overlay {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background-image: radial-gradient(#e2e8f0 0.8px, transparent 0.8px);
          background-size: 24px 24px;
          opacity: 0.5;
          pointer-events: none;
        }

        .auth-card-container {
          width: 100%;
          max-width: 520px;
          position: relative;
          z-index: 30;
          animation: fadeInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .login-floating-card {
          background: white;
          padding: 60px 50px;
          border-radius: 40px;
          box-shadow: 0 40px 80px -20px rgba(0, 0, 0, 0.15), 
                      0 0 0 1px rgba(0, 0, 0, 0.02);
          border: 1px solid rgba(255, 255, 255, 0.8);
          position: relative;
          overflow: hidden;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .mobile-logo-container {
          display: none;
          text-align: center;
          margin-bottom: 40px;
        }

        @media (max-width: 767px) {
          .auth-left-identity {
            display: none;
          }
          .auth-right-workspace {
            padding: 20px;
          }
          .login-floating-card {
            padding: 40px 25px;
            border-radius: 24px;
          }
          .mobile-logo-container {
            display: block;
          }
          .mobile-logo {
            height: 50px;
          }
        }

        /* Liquid BG Styling - VIBRANT MODE */
        .liquid-bg {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: linear-gradient(-45deg, #1e3a8a, #3b82f6, #06b6d4, #8b5cf6);
          background-size: 400% 400%;
          animation: gradientShift 15s ease infinite;
        }

        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        .wave {
          position: absolute;
          width: 300%; height: 300%;
          border-radius: 40%;
          opacity: 0.25;
          filter: blur(40px);
        }

        .wave-1 {
          top: -150%; left: -50%;
          background: radial-gradient(circle, #3b82f6 0%, transparent 60%);
          animation: liquidMove 12s infinite linear;
        }

        .wave-2 {
          top: -120%; left: -30%;
          background: radial-gradient(circle, #8b5cf6 0%, transparent 60%);
          animation: liquidMove 18s infinite linear reverse;
        }

        .wave-3 {
          bottom: -150%; right: -50%;
          background: radial-gradient(circle, #0ea5e9 0%, transparent 60%);
          animation: liquidMove 15s infinite linear;
        }

        @keyframes liquidMove {
          0% { transform: rotate(0deg) scale(1); }
          100% { transform: rotate(360deg) scale(1); }
        }

        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-15px); }
        }
      `}</style>
    </div>
  );
};

export default AuthLayout;
